import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./ResetAlias.module.css";

// Remplacez ces imports d'icônes par vos fichiers user.svg et alias.svg
import userIcon from "./svg/user.svg";
import aliasIcon from "./svg/Alias.svg";

// Import du thunk et selector du slice ResetAlias
import {
  fetchResetAlias,
  resetAliasSelector,
  resetAliasClear,
} from "./resetAliasSlice";

const ResetAlias = () => {
  const dispatch = useDispatch();
  const utilisateur = useSelector((state) => state.connexion.utilisateur);
  const { loading, hasErrors, success, message } = useSelector(resetAliasSelector);

  const [newAlias, setNewAlias] = useState("");
  const [confirmAlias, setConfirmAlias] = useState("");
  const [localError, setLocalError] = useState("");

  // Réinitialise l'état du slice ResetAlias au montage du composant
  useEffect(() => {
    dispatch(resetAliasClear());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Vérification locale
    if (!newAlias) {
      setLocalError("Veuillez saisir un nouvel alias.");
      return;
    }
    if (newAlias !== confirmAlias) {
      setLocalError("Les alias ne correspondent pas.");
      return;
    }
    // Vérifier que l'alias contient au moins 6 caractères
    const regex = /^.{6,}$/;
    if (!regex.test(newAlias)) {
      setLocalError("L'alias doit contenir au moins 6 caractères.");
      return;
    }
    setLocalError("");
    // Dispatch de l'appel API pour modifier l'alias
    dispatch(fetchResetAlias({ id: utilisateur.id, newAlias }));
  };

  return (
    <div className={styles.container}>
      {/* Conteneur d'icônes : user.svg et alias.svg */}
      <div className={styles.iconContainer}>
        <img src={userIcon} alt="Icône d'utilisateur" className={styles.icon} />
        <img src={aliasIcon} alt="Icône d'alias" className={styles.icon} />
      </div>

      {/* Affichage des messages */}
      {success && message && (
        <div className={styles.successBanner}>{message}</div>
      )}
      {(localError || (hasErrors && message)) && (
        <div className={styles.errorBanner}>
          {localError || message}
        </div>
      )}

      {/* Formulaire de modification de l'alias */}
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Nouvel alias - 6 caractères min"
          className={styles.input}
          value={newAlias}
          onChange={(e) => setNewAlias(e.target.value)}
        />
        <input
          type="text"
          placeholder="Confirmer nouvel alias"
          className={styles.input}
          value={confirmAlias}
          onChange={(e) => setConfirmAlias(e.target.value)}
        />
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? "Chargement..." : "Valider"}
        </button>
      </form>
    </div>
  );
};

export default ResetAlias;
